// Lightweight fetch wrapper that attaches JWT and handles 401 redirects
export async function apiFetch(path, options = {}) {
  const token = localStorage.getItem('accessToken');
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const response = await fetch(path, { ...options, headers });

  if (response.status === 401) {
    // Clear token and redirect to login
    try { localStorage.removeItem('accessToken'); } catch (_) {}
    // Try to extract server message for debugging (non-blocking)
    try { await response.clone().json(); } catch (_) {}
    window.location.href = '/login';
    throw new Error('Neautorizat. Vă rugăm să vă autentificați din nou.');
  }

  return response;
}

// Packet of Truth (POT) API
export const fetchClientPOT = async (clientId) => {
  const res = await apiFetch(`/api/clients/${clientId}/pot`);
  if (!res.ok) throw new Error('Failed to fetch POT');
  return res.json();
};

export const updateClientPOT = async (clientId, data) => {
  const res = await apiFetch(`/api/clients/${clientId}/pot`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error('Failed to update POT');
  return res.json();
};